import React from "react";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import VideoPlayer from "../YoutubePlayer/YoutubePlayer";
import allPaths from "../../Config/paths"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Testimonials = (props) => {
    const { selectedLanguage } = props;
    const history = useHistory()
    return (
        <div>
            <HeaderComponent title={selectedLanguage?.txt_testimonials} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-testimonial-video-player">
                <VideoPlayer videoUrl='https://www.youtube.com/embed/phvAW5rIP_Y'/>
            </div>
            <div className="fifth-des-more-btn-div">
                <button onClick={()=>history?.push(allPaths?.FIFHTTESTIMONIALS)} className="fifth-des-more-btn">
                    {selectedLanguage?.txt_more}
                </button>
            </div>
        </div>
    )
}
export default Testimonials